// extracted by mini-css-extract-plugin
export var active = "_kl-2";
export var recordingDot = "_kl-1";
export var recordingIndicator = "_kl-0";